<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:</label>
    <Datepicker menuClassName="dp-custom-range-input" v-model="this.value" :enableTimePicker="false" :range="true" :format="format" autoApply :class="{ error: error }" locale="pt-BR" @update:modelValue="$emit('update:modelValue', modelValue)">
      <template #dp-input="{ value, onInput, onEnter, onTab, onClear }">
        <input ref="input" :id="id" v-bind="{ ...$attrs, class: null }" class="form-input" :class="{ error: error }" :type="type" :value="value" readonly />
      </template>
    </Datepicker>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import ptBR from 'date-fns/locale/pt-BR';
import parse from 'date-fns/parse';
import format from 'date-fns/format';

export default {
  data() {
    return {
      value: [],
    }
  },
  mounted() {
    if(this.modelValue) {
      this.value = this.modelValue;
    }
  },
  watch: {
    value(valueNew, valueOld) {
      this.$emit('update:modelValue', this.value);
    },
  },
  components: {
    Datepicker,
    ptBR,
    format,
    parse,
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `range-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    modelValue: Array,
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
    format(date) {
      let input = '';
      if(date && date[0] && date[1]) {
        input += this.$filters.formatDate(date[0]) + ' - ' + this.$filters.formatDate(date[1]);
      }
      return input;
    }
  },
}
</script>
<style>
.dp-custom-range-input .dp__overlay_cell_active,
.dp-custom-range-input .dp__range_start,
.dp-custom-range-input .dp__range_end,
.dp-custom-range-input .dp__active_date {
  background-color: var(--color-primary);
}
</style>
